export default {
  'searchPartStock.column.company': 'Empresa',
  'searchPartStock.column.minimumStock': 'Estoque Mínimo',
  'searchPartStock.column.stock': 'Estoque',
  'searchPartStock.column.availableStock': 'Venda	Disponível',
  'searchPartStock.column.location': 'Localização',
  'searchPartStock.column.salePrice': 'Preço de Venda',
  'searchPartStock.column.costPrice': 'Preço de Custo',
  'searchPartStock.column.realCost': 'Custo Real',
  'searchPartStock.column.internalCode': 'Código Interno',
  'searchPartStock.column.manufacturerCode': 'Código Fabricante',
  'searchPartStock.column.title.description': 'Descrição',
};
